import { resumeSlice } from "./resumeSlice";

const { actions } = resumeSlice;

export const resumeActions = actions;